import { ReactNode } from 'react'
import NextLink from 'next/link'
import classNames from 'classnames'

interface LinkProps {
  title?: string
  href: string
  className?: string
  replace?: boolean
  prefetch?: boolean
  rel?: string
  target?: string
  children: ReactNode
}

export function Link({
  title,
  href,
  className,
  replace,
  prefetch,
  rel,
  target,
  children,
}: LinkProps) {
  return (
    <NextLink
      title={title}
      href={href}
      className={classNames('link', className)}
      replace={replace}
      prefetch={prefetch}
      rel={rel}
      target={target}
    >
      {children}
    </NextLink>
  )
}
